// onRowClicked do DataTable: abre o detalhe da linha. getLocation(row) devolve
// { pathname, state? }. Não navega se o usuário estava selecionando texto
// (ex.: copiar um código); Ctrl/Cmd/Shift + clique abre em nova aba.
export function rowClickHandler(history, getLocation) {
  return (row, event) => {
    if (window.getSelection()?.toString()) return;
    const location = getLocation(row);
    if (event.ctrlKey || event.metaKey || event.shiftKey) {
      window.open(location.pathname, '_blank');
      return;
    }
    history.push(location);
  };
}
